module.exports = __webpack_public_path__ + "img/player-box.cc8567ef.png";